@let searchOptions = searchOptions$ | async;

@if (searchOptions) {
<div class="landing-page-search" [class.landing-page-search--sticky]="isSticky">

    <rpc-button-toggle class="landing-page-search-filter landing-page-search-filter--toggle"
        [default]="searchOptions.categoryId === listingCategoryIds.Sales ? listingCategory.Sales : listingCategory.Rental"
        [items]="categoryItems" [color]="'accent'">
    </rpc-button-toggle>

    <omni-search class="landing-page-search-filter landing-page-search-filter--omni" [iconName]="'pin'"
        [selectedPatternSearchResults]="searchOptions.patternSearchResult">
    </omni-search>

    <rpc-button class="landing-page-search-filter landing-page-search-filter--select" [appearanceType]="'stroke'"
        [actionTrigger]="searchOptions.priceSearchOption != null && (searchOptions.priceSearchOption.min != null || searchOptions.priceSearchOption.max != null)"
        [actionClass]="'rpc-active'" [text]="priceTitle" [hasTrigger]="true" [rpcDropdown]="priceFilter"
        [dropdownCustomClass]="'landing-page-search-filter-dropdown-wrap'">
    </rpc-button>

    <rpc-button class="landing-page-search-filter landing-page-search-filter--select" [appearanceType]="'stroke'"
        [actionTrigger]="searchOptions.bedSearchOption != null && !searchOptions.bedSearchOption.any && searchOptions.bedSearchOption.values?.length > 0"
        [actionClass]="'rpc-active'" [text]="bedsTitle" [hasTrigger]="true" [rpcDropdown]="bedsFilter"
        [dropdownCustomClass]="'landing-page-search-filter-dropdown-wrap'">
    </rpc-button>

    <rpc-button class="landing-page-search-btn" [iconName]="'search'"
        [title]="'LANDING_SEARCH.TITLES.SEARCH' | translate" [color]="'accent'" [appearanceType]="'flat'"
        (clicked)="onSearch()">
    </rpc-button>

    <ng-template #priceFilter>

        <div class="landing-page-search-filter-droprown">

            @let priceMinMaxData = searchOptions.categoryId === listingCategoryIds.Sales
            ? searchFilterInitialValues.salesPriceMinMaxData
            : searchFilterInitialValues.rentalsPriceMinMaxData;

            <range-filter [min]="priceMinMaxData.min" [max]="priceMinMaxData.max" [step]="priceMinMaxData.step"
                [sliderMin]="priceMinMaxData.slider.min" [sliderMax]="priceMinMaxData.slider.max"
                [selectedValue]="searchOptions.priceSearchOption" [minFormControlName]="'priceMin'"
                [maxFormControlName]="'priceMax'" [isCurrency]="true" (valueChanged)="onPriceChanged($event)">
            </range-filter>

        </div>

    </ng-template>

    <ng-template #bedsFilter>

        <div class="landing-page-search-filter-droprown">

            <checkbox-filter [values]="bedsValues" [selectedValues]="searchOptions.bedSearchOption.values"
                [isAny]="searchOptions.bedSearchOption.any" [isExactMatch]="searchOptions.bedSearchOption.exactMatch"
                (valueChanged)="onBedsChanged($event)">
            </checkbox-filter>

        </div>

    </ng-template>

</div>
}